import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import { HistoryOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';

import OnTraccrButton from '../../common/buttons/OnTraccrButton';
import {
  getOTSettingsVersions,
} from '../state/settings.actions';
import { formatOTSettingsHistoryDate } from '../../helpers/overtime/overtimeSettingsHelpers';
import OvertimeSettingsHistoryDrawer from './OvertimeSettingsHistoryDrawer';

export default function OvertimeSettingsStatus({
  otProfileId,
}) {
  const dispatch = useDispatch();
  const versionsKey = otProfileId || 'company';

  const otSettingsVersions = useSelector((state) => state.settings.otSettingsVersions);

  const status = otSettingsVersions?.[versionsKey];

  const [loading, setLoading] = useState(true);
  const [historyOpen, setHistoryOpen] = useState(false);

  const fetchStatus = useCallback(async () => {
    setLoading(true);
    await dispatch(getOTSettingsVersions(otProfileId));
    setLoading(false);
  }, [otProfileId]);

  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  const isPending = status?.status === 'pending' && status?.pendingEffectiveDate;

  const statusMessage = useMemo(() => {
    if (!status) return '—';
    if (isPending) {
      return `Takes effect ${formatOTSettingsHistoryDate(status.pendingEffectiveDate)}`;
    }
    return 'Currently active';
  }, [status, isPending]);

  return (
    <>
      <div className="overtime-settings-status-bar">
        <div
          className={`overtime-settings-status-text ${isPending ? 'is-pending' : 'is-active'}`}
        >
          {loading ? <Spin size="small" /> : statusMessage}
        </div>
        <OnTraccrButton
          title="History"
          type="primary"
          className="overtime-settings-history-btn"
          icon={<HistoryOutlined />}
          onClick={() => setHistoryOpen(true)}
        />
      </div>
      <OvertimeSettingsHistoryDrawer
        visible={historyOpen}
        onClose={() => setHistoryOpen(false)}
        otProfileId={otProfileId}
        loading={loading}
      />
    </>
  );
}

OvertimeSettingsStatus.propTypes = {
  otProfileId: PropTypes.string,
};

OvertimeSettingsStatus.defaultProps = {
  otProfileId: null,
};
